import axios from "axios"

import { API_URL } from '../../config/appConfig';

export const ORG_UTILITIES_URL = `${API_URL}/api/Utilities`

export const getModelSettings = (modelType: string) => {
  return axios.get(`${ORG_UTILITIES_URL}/modelsettings?model=${modelType}`);
}

export const getDropDownLists = () => {
  return axios.get(`${ORG_UTILITIES_URL}/DropdownContent`);
}

export const getEnumLists = () => {
  return axios.get(`${ORG_UTILITIES_URL}/EnumDescriptions`);
}

export const getPortfolioAllocationTypes = () => {
  return axios.get(`${ORG_UTILITIES_URL}/PortfolioAllocationTypes`);
}

export const getCountriesList = () => {
  return axios.get(`${ORG_UTILITIES_URL}/countries`)
}

export const getInstrumentModelSettings = (modelType : string) => {
  return axios.get(`${ORG_UTILITIES_URL}/modelsettings?model=${modelType}`)
}

export const generateNSM =  () => {
  return axios.get(`${ORG_UTILITIES_URL}/nsm`)
} 

export const getSymbolStatus = (symbol : string, nsm : string) => {
  return axios.get(`${ORG_UTILITIES_URL}/status/symbol/${symbol}/${nsm}`)
}

export const postValidateModel = (modelName : string, propertyName : string, payload : any) => {
  return axios.post(`${ORG_UTILITIES_URL}/validateProperty/${modelName}/${propertyName}`, payload)
}

export const getListingExchanges = () => {
  return axios.get(`${ORG_UTILITIES_URL}/listingExchanges`)
}

export const getSymbols = (params : any, headers : any) => {
  return axios.post(`${ORG_UTILITIES_URL}/symbolGenerator`, {},{params, headers})
}

export const getCusipStatus = (cusip : string, nsm : string) => {
  return axios.get(`${ORG_UTILITIES_URL}/status/cusip/${cusip}/${nsm}`)
}

export const getIsinStatus = (isin : string, nsm : string) => {
  return axios.get(`${ORG_UTILITIES_URL}/status/isin/${isin}/${nsm}`)
}

export const getMarketCloseDays = (params : any, headers : any) => {
  return axios.get(`${ORG_UTILITIES_URL}/MarketClosedDaysUSNasdaqHolidays`, {params, headers})
}

export const getMarketCloseDaysCustom = (params : any, headers : any) => {
  return axios.get(`${ORG_UTILITIES_URL}/MarketClosedDaysCustom`, {params, headers})
}

export const deleteMarketCloseDayCustom = (params : any, headers : any) => {
  return axios.delete(`${ORG_UTILITIES_URL}/MarketClosedDaysCustom`, {params, headers})
}

export const postMarketCloseDayCustom = (params : any, headers : any) => {
  return axios.post(`${ORG_UTILITIES_URL}/MarketClosedDaysCustom`,{},{params, headers})
}